import { Component, Input, OnInit } from "@angular/core";

export class ActionResultData {
    public message: string;
    public success: boolean;
    public timeout: number;
    public timeoutCallback: () => void;

    constructor(message: string, success: boolean, timeout: number, timeoutCallback: () => void) {
        this.message = message;
        this.success = success;
        this.timeout = timeout;
        this.timeoutCallback = timeoutCallback;
    }
}

@Component({
    selector: 'action-result',
    templateUrl: './actionResult.component.html',
    styleUrls: ['./actionResult.component.css'],
    standalone: false
})
export class ActionResultComponent implements OnInit {
    @Input() public data: ActionResultData;

    public ngOnInit(): void {
        setTimeout(this.data.timeoutCallback, this.data.timeout);
    }
}